import { Controller } from 'react-hook-form';

import { ReimbursementSelectorProps } from './ReimbursementSelector.types';
import { ReimbursementSelectorContent } from './ReimbursementSelectorContent';

export const ReimbursementSelector = (props: ReimbursementSelectorProps): JSX.Element => {
   return (
      <Controller
         control={props.controller.control}
         defaultValue={props.defaultValue}
         name={props.controller.name}
         rules={props.controller.validationRules}
         render={({ onChange, onBlur, value }) => (
            <ReimbursementSelectorContent
               selectedEntitlements={props.selectedEntitlements}
               visitDiagnoses={props.visitDiagnoses}
               reimbursements={props.reimbursements}
               error={props.controller.error}
               onBlur={onBlur}
               onChange={onChange}
               value={value}
               disabled={props.disabled}
               testId={props.testId}
            />
         )}
      />
   );
};
